module.exports = __webpack_public_path__ + "static/media/verset_corner_lower_right.c3d44c8e.png";